<template>
  <form @submit.prevent="productsFilters">
    <div class="row mb-5 pb-3">
      <div class="align-self-end col-sm-4 col-lg-6 col-12">
        <div class="form-group">
          <label for="product-filter" class="mb-2">{{ translate("PRODUCT.FILTERS.NAME_LABEL") }}</label>
          <input
            id="product-filter"
            v-model.trim="label"
            class="form-control"
            :placeholder="translate('PRODUCT.FILTERS.NAME_PLACEHOLDER')"
          />
        </div>
      </div>

      <div class="mt-5 align-self-end col-sm-4 col-lg-3 col-12">
        <div class="form-group">
          <label for="status-filter" class="mb-2">{{ translate("PRODUCT.FILTERS.STATUS_LABEL") }}</label>
          <select id="status-filter" v-model="status" class="cirx-filter custom-select">
            <option value="">
              {{ translate("PRODUCT.CREATE_FORM.STATUS_ALL") }}
            </option>
            <option :value="ProductStatusType.DRAFT">
              {{ translate("PRODUCT.CREATE_FORM.STATUS_DRAFT") }}
            </option>
            <option :value="ProductStatusType.PUBLISHED" selected>
              {{ translate("PRODUCT.CREATE_FORM.STATUS_PUBLISHED") }}
            </option>
          </select>
        </div>
      </div>

      <div class="mt-5 align-self-end col-sm-4 col-lg-3 col-12">
        <ProductsFiltersPrice v-model="price" />
      </div>

      <div class="mt-5 mt-sm-0 align-self-end col-sm-4 col-lg-6 col-12">
        <label class="mb-2">{{ translate("PRODUCT.FILTERS.CATEGORY_LABEL") }}</label>
        <TreeSelectCategory v-model="categories" id="category-filter" />
      </div>
    </div>

    <div class="row mb-8 pb-3 justify-content-between">
      <div class="align-self-end col-sm-12 col-lg-4">
        <button
          type="submit"
          class="btn btn-primary cirx-custom-primary-color-btn"
          :class="{ 'w-100': isViewportMobile() }"
        >
          {{ translate("PRODUCT.FILTERS.SEARCH") }}
        </button>
        <button
          class="btn btn-secondary"
          type="reset"
          :class="isViewportMobile() ? 'w-100 mt-5' : 'ml-5'"
          @click="resetFilters"
        >
          {{ translate("PRODUCT.FILTERS.CLEAR") }}
        </button>
      </div>
    </div>

    <hr v-if="isViewportMobile()" class="m-0" />
  </form>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { inject, onMounted, ref } from "vue";
import TreeSelectCategory from "@/view/components/CategoryFilter/TreeSelectCategory.vue";
import { ProductStatusType } from "@/apps/dashboard/catalog/core/infrastructure/service/productsService";
import ProductsFiltersPrice from "@/apps/dashboard/catalog/view/Products/ProductsFiltersPrice.vue";
import useTranslate from "@/core/composables/translate";

const { translate } = useTranslate();

const isViewportMobile = inject("isViewportMobile");

const { modelValue } = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});

onMounted(() => {
  label.value = modelValue.label;
  status.value = modelValue.status;
  price.value = modelValue.price;
  categories.value = modelValue.categories;
});

const emits = defineEmits(["filter"]);

const label = ref("");
const status = ref(ProductStatusType.PUBLISHED);
const price = ref({ min: "", max: "" });
const categories = ref([]);

const productsFilters = () => {
  const filters = {
    label: label.value,
    price: price.value,
    categories: Array.isArray(categories.value) ? categories.value : [categories.value],
    status: status.value,
  };

  emits("filter", filters);
};

const resetFilters = () => {
  label.value = "";
  price.value = { min: "", max: "" };
  categories.value = [];
  status.value = ProductStatusType.PUBLISHED;
};
</script>
